module.exports = __webpack_public_path__ + "static/media/p7.2d9d10f5.jpeg";